import React, { ReactNode, useCallback, useRef } from 'react'
import tw from 'twin.macro'
import { useLocation, useNavigate } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { ReactComponent as BackgroundImage } from 'src/assets/images/background.svg'
import { ClientMobileStepsHeader } from './ClientMobileStepsHeader'
import { useMediaQueries } from 'src/hooks/useMediaQueries'
import { ClientStepsHeader } from './ClientStepsHeader'
import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { Footer } from 'src/components/shared/Footer'
import { getIsTokenSignIn } from 'src/selectors/auth'
import { useSelector } from 'react-redux'

interface Props {
  children?: ReactNode
  onBack?: () => void
  onSkip?: () => void
}

export const ClientSecureWrapper = ({ children, onBack, onSkip }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  const modalContainerRef = useRef<HTMLDivElement>(null)

  const { isMobile, isDesktopOrTablet } = useMediaQueries()

  const isIsTokenSignIn = useSelector(getIsTokenSignIn)

  const handleBack = useCallback(() => {
    if (location.key === 'default') {
      navigate(CLIENT_ROUTES.HOME_URL)

      return
    }

    navigate(-1)
  }, [location])

  const handleGetHelp = useCallback(() => {
    showIntercom()
  }, [])

  return (
    <div css={tw`h-full w-full flex flex-col`}>
      <div css={tw`flex flex-1 bg-primary-800 items-center justify-center flex-col lg:py-16`}>
        <BackgroundImage css={tw`fixed top-0 bottom-0 z-0 h-full [&>path]:fill-primary-900`} />
        <div
          ref={modalContainerRef}
          css={tw`bg-shades-0 sm:max-w-[390px] mx-4 sm:min-h-[80vh] w-full flex flex-1 sm:flex-none flex-col sm:rounded-2xl overflow-hidden z-10 sm:my-4 relative`}
        >
          {isMobile && (
            <>
              <ClientMobileStepsHeader
                hideSettings={!!isIsTokenSignIn}
                onBack={onBack}
                onSkip={onSkip}
                handleGetHelp={handleGetHelp}
                handleBack={handleBack}
              />
              <div
                css={tw`flex flex-1 bg-shades-50 items-center pt-20 p-4 justify-center flex-col`}
              >
                {children}
              </div>
            </>
          )}
          {isDesktopOrTablet && (
            <>
              <ClientStepsHeader
                hideSettings={!!isIsTokenSignIn}
                modalContainerRef={modalContainerRef}
                onBack={onBack}
                onSkip={onSkip}
                handleGetHelp={handleGetHelp}
                handleBack={handleBack}
              />
              <div
                css={tw`flex flex-1 bg-shades-50 items-center justify-center flex-col px-4 py-4`}
              >
                {children}
              </div>
            </>
          )}

          <Footer
            className={tw`flex items-center px-4 pt-2 pb-7 bg-shades-50 justify-center w-full`}
          />
        </div>
      </div>
    </div>
  )
}
